import Errors from '../i18n/errors.json'
import { ApplicationError, type ErrorType } from '../types'

interface ErrorDetails {
	type: string
	message: string
	code: string
}

export class BackendErrors {
	private static readonly _errors: Record<string, ErrorDetails> = Errors

	static check(
		error: ApplicationError,
		defaultErrorCode: string
	): ApplicationError {
		// Initialize errorDetails with the defaultErrorCode to ensure we have a valid error detail.
		// Since we can't guarantee that the backend will return an error code that exists in our errors.json,
		// we use the default as a fallback.
		let errorDetails = BackendErrors._errors[defaultErrorCode]!

		// If error.code exists and we have a matching entry in errors.json,
		// we update errorDetails with the specific error information.
		if (error.code && BackendErrors._errors[error.code]) {
			errorDetails = BackendErrors._errors[error.code]!
		}

		return new ApplicationError({
			type: errorDetails.type as ErrorType,
			message: errorDetails.message,
			code: errorDetails.code
		})
	}
}
